import QRCode from 'react-qr-code';
import { useQrCodeStyles } from './qr-code.styles';

export function QrCode({ qrCode }: { qrCode: string }) {
  const classes = useQrCodeStyles();
  return (
    <svg
      className={classes.qrCode}
      width="100%"
      height="100%"
      viewBox="0 0 190 190"
      style={{ maxWidth: '190px', maxHeight: '190px' }}
    >
      <QRCode value={qrCode} size={190} />
    </svg>
  );
}
